import React from 'react';
import { Box, Flex, Text } from 'pcln-design-system';
import { StyledLoadingBox } from '../../StyledLoadingBubble';
import styled from 'styled-components';
const ellipsisProps = {
  width: '10px',
  height: '10px',
  borderRadius: '5px',
  bg: '#868d95'
};
const LoadingWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Loading__LoadingWrapper",
  componentId: "sc-keja0f-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;"]);
const Loading = () => {
  return React.createElement(LoadingWrapper, null, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Text, {
    fontSize: 3
  }, " Loading "), React.createElement(StyledLoadingBox, {
    mt: 1,
    width: '62px',
    height: '32px',
    align: 'center',
    justifyContent: 'space-between'
  }, React.createElement(Box, Object.assign({}, ellipsisProps, {
    id: 'ellipses_1'
  })), React.createElement(Box, Object.assign({}, ellipsisProps, {
    id: 'ellipses_2'
  })), React.createElement(Box, Object.assign({}, ellipsisProps, {
    id: 'ellipses_3'
  })))));
};
export default Loading;